import React from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as Right } from 'assets/images/icons/chevron_right-24px.svg'
import { ReactComponent as Left } from 'assets/images/icons/chevron_left-24px.svg'
import { addMonths, addDays, addWeeks, isValid } from 'date-fns'
import { Flex } from '@jisr-hr/design-system'
import { format } from 'utils/date'
import DatePicker from 'components/global/DatePicker'
import { Typography } from '@jisr-hr/ds'

const CustomInput = React.forwardRef(({ value, onClick, dateFormat }, ref) => {
  return (
    <Typography
      text={format(value, dateFormat)}
      variant="subheading"
      ref={ref}
      className="pointer"
      onClick={onClick}
    />
  )
})

const Calendar = ({
  showMonthPicker,
  popperPlacement,
  onChangeDate,
  showWeekPicker,
  initDate,
  maxDate,
  minDate,
  value,
}) => {
  const [newdate, setNewdate] = React.useState(new Date())
  function handleOnChange(date) {
    setNewdate(new Date(date))
    onChangeDate(new Date(date))
  }

  React.useEffect(() => {
    if (isValid(initDate)) setNewdate(new Date(initDate))
  }, [initDate])

  React.useEffect(() => {
    if (isValid(value)) setNewdate(new Date(value))
  }, [value])

  function handleOnClickNext() {
    if (showMonthPicker) {
      const next = addMonths(newdate, 1)
      handleOnChange(next)
    } else if (showWeekPicker) {
      const next = addWeeks(newdate, 1)
      handleOnChange(next)
    } else {
      const next = addDays(newdate, 1)
      handleOnChange(next)
    }
  }

  function handleOnClickPrevious() {
    if (showMonthPicker) {
      const previous = addMonths(newdate, -1)
      handleOnChange(previous)
    } else if (showWeekPicker) {
      const previous = addWeeks(newdate, -1)
      handleOnChange(previous)
    } else {
      const previous = addDays(newdate, -1)
      handleOnChange(previous)
    }
  }

  // function isWeekday(date) {
  //   const day = getDay(date);
  //   return day === 0;
  // }

  return (
    <div className="calander-appear">
      <Flex>
        <Left
          className="rotateIcon"
          onClick={handleOnClickPrevious}
          data-testid="calendar-box-Left"
        />
        <DatePicker
          events={[]}
          customInput={
            <CustomInput dateFormat={showMonthPicker ? 'MMMM, yyyy' : 'eeee dd MMMM, yyyy'} />
          }
          selected={newdate}
          dateFormat="yyyy-MM-dd"
          onChange={handleOnChange}
          showMonthYearPicker={showMonthPicker}
          isMonthPicker={showMonthPicker}
          popperPlacement={popperPlacement}
          // filterDate={showWeekPicker && isWeekday}
          maxDate={maxDate}
          minDate={minDate}
          hideMonthDropdown
          hideYearDropdown
        />
        <Right
          className="rotateIcon"
          onClick={handleOnClickNext}
        />
      </Flex>
    </div>
  )
}

CustomInput.propTypes = {
  value: PropTypes.string,
  dateFormat: PropTypes.string,
  onClick: PropTypes.func,
}

Calendar.propTypes = {
  onChangeDate: PropTypes.func,
  showMonthPicker: PropTypes.bool,
  showWeekPicker: PropTypes.bool,
  popperPlacement: PropTypes.string,
  initDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
}

Calendar.defaultProps = {
  showMonthPicker: false,
  showWeekPicker: false,
  popperPlacement: 'bottom',
}

export default React.memo(Calendar)
